<template>
  <section class="btn-announcements-page">
    <div class="btn-announcements-page__content">
      <h1 class="btn-announcements-page__title">Recent Announcements</h1>
      <ul class="btn-announcements-page__list">
        <li
          v-for="announcement in announcements"
          :key="announcement.id"
          class="btn-announcements-page__list-item"
        >
          <PreviewAnnouncement :announcement="announcement" />
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import PreviewAnnouncement from '~/components/products/by-the-numbers/PreviewAnnouncement.vue';

  export default {
    name: 'ByTheNumbersAnnouncementPage',
    components: {
      PreviewAnnouncement,
    },
    props: {
      announcements: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-announcements-page {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    min-height: 75vh;

    &__content {
      padding: 0;
      margin: 0;
      max-width: 800px;
    }

    &__title {
      font-size: 36px;
      margin-bottom: 55px;
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 0;

      display: flex;
      flex-direction: column;
      gap: 65px;

      &-item {
        width: 100%;
        padding: 0;
        margin: 0;
      }
    }
  }
</style>
